import { checkIdentityLogin } from '@/modules/oidc';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { AUTH_ROUTES } from '../../contants/routes';

const AuthVerifyToken = React.lazy(() => import('../pages/AuthPages/AuthVerifyToken'));
const AuthVerifyUser = React.lazy(() => import('../pages/AuthPages/AuthVerifyUser'));
const ForgotPasswordPage = React.lazy(() => import('../pages/AuthPages/ForgotPasswordPage'));
const LoginPage = React.lazy(() => import('../pages/AuthPages/LoginPage'));
const RegistrationPage = React.lazy(() => import('../pages/AuthPages/RegistrationPage'));
const AuthPage = React.lazy(() => import('../pages/AuthPages/AuthPage'));

const AuthRoutes = () => {
  const { user } = useSelector((state) => state.auth);

  const { isIdentityLogin } = checkIdentityLogin();

  const isOldFlowLogged = user?.data;
  const isMFAInProgress = user?.data?.twoFactorEnabled;

  if ((!isOldFlowLogged || isMFAInProgress) && !isIdentityLogin) {
    return (
      <Routes>
        <Route path={AUTH_ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={AUTH_ROUTES.AUTH} element={<AuthPage />} />
        <Route path={AUTH_ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={AUTH_ROUTES.REGISTER} element={<RegistrationPage />} />
        <Route path={AUTH_ROUTES.USER_SEND_AUTHENTICATION_TOKEN} element={<AuthVerifyUser />} />
        <Route path={AUTH_ROUTES.USER_VERIFY_AUTHENTICATION_TOKEN} element={<AuthVerifyToken />} />
      </Routes>
    );
  }
  return <Fragment />;
};

export default AuthRoutes;
